var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8857F7F6-3F7D-4B74-9BE5-94BFF9D31E27") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Styleguide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-740.000000, -3215.000000)",
    fill: "#545D61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(127.000000, 3160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/share",
    transform: "translate(613.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1875,14.375 C15.261375,14.375 14.4384688,14.8250625 13.9256875,15.5178438 L9.511,13.26175 C9.5850625,13.010125 9.625,12.7440313 9.625,12.46875 C9.625,12.0959063 9.55190625,11.739875 9.4195625,11.4139688 L14.0464375,8.63403125 C14.5626875,9.23996875 15.3309375,9.625 16.1875,9.625 C17.7383125,9.625 19,8.3633125 19,6.8125 C19,5.2616875 17.7383125,4 16.1875,4 C14.6366875,4 13.375,5.2616875 13.375,6.8125 C13.375,7.1709375 13.4425313,7.51384375 13.5653125,7.829375 L8.926875,10.61625 C8.411,10.0281875 7.65440625,9.65625 6.8125,9.65625 C5.2616875,9.65625 4,10.9179375 4,12.46875 C4,14.0195625 5.2616875,15.28125 6.8125,15.28125 C7.7538125,15.28125 8.5885,14.816375 9.09928125,14.1041875 L13.5011563,16.3537187 C13.4191875,16.6172812 13.375,16.8973125 13.375,17.1875 C13.375,18.7383125 14.6366875,20 16.1875,20 C17.7383125,20 19,18.7383125 19,17.1875 C19,15.6366875 17.7383125,14.375 16.1875,14.375 Z M16.1875,4.9375 C17.221375,4.9375 18.0625,5.778625 18.0625,6.8125 C18.0625,7.846375 17.221375,8.6875 16.1875,8.6875 C15.153625,8.6875 14.3125,7.846375 14.3125,6.8125 C14.3125,5.778625 15.153625,4.9375 16.1875,4.9375 Z M6.8125,14.34375 C5.778625,14.34375 4.9375,13.502625 4.9375,12.46875 C4.9375,11.434875 5.778625,10.59375 6.8125,10.59375 C7.846375,10.59375 8.6875,11.434875 8.6875,12.46875 C8.6875,13.502625 7.846375,14.34375 6.8125,14.34375 Z M16.1875,19.0625 C15.153625,19.0625 14.3125,18.221375 14.3125,17.1875 C14.3125,16.153625 15.153625,15.3125 16.1875,15.3125 C17.221375,15.3125 18.0625,16.153625 18.0625,17.1875 C18.0625,18.221375 17.221375,19.0625 16.1875,19.0625 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3391f3c9.svg";
export { ForwardRef as ReactComponent };